module.exports = __webpack_public_path__ + "static/media/19ESCAP46.1a41eaac.jpg";